// extracted by mini-css-extract-plugin
export var grid = "_35-0";
export var span1 = "_35-2";
export var span10 = "_35-b";
export var span10L = "_35-z";
export var span10M = "_35-n";
export var span10Xl = "_35-1b";
export var span11 = "_35-c";
export var span11L = "_35-10";
export var span11M = "_35-o";
export var span11Xl = "_35-1c";
export var span12 = "_35-d";
export var span12L = "_35-11";
export var span12M = "_35-p";
export var span12Xl = "_35-1d";
export var span1L = "_35-q";
export var span1M = "_35-e";
export var span1Xl = "_35-12";
export var span2 = "_35-3";
export var span2L = "_35-r";
export var span2M = "_35-f";
export var span2Xl = "_35-13";
export var span3 = "_35-4";
export var span3L = "_35-s";
export var span3M = "_35-g";
export var span3Xl = "_35-14";
export var span4 = "_35-5";
export var span4L = "_35-t";
export var span4M = "_35-h";
export var span4Xl = "_35-15";
export var span5 = "_35-6";
export var span5L = "_35-u";
export var span5M = "_35-i";
export var span5Xl = "_35-16";
export var span6 = "_35-7";
export var span6L = "_35-v";
export var span6M = "_35-j";
export var span6Xl = "_35-17";
export var span7 = "_35-8";
export var span7L = "_35-w";
export var span7M = "_35-k";
export var span7Xl = "_35-18";
export var span8 = "_35-9";
export var span8L = "_35-x";
export var span8M = "_35-l";
export var span8Xl = "_35-19";
export var span9 = "_35-a";
export var span9L = "_35-y";
export var span9M = "_35-m";
export var span9Xl = "_35-1a";
export var stretch = "_35-1";